<div class="register-card" [class.register-card-plain]="buttonOnly">
    <div class="register-card-title" *ngIf="!buttonOnly">{{title}}</div>

    <!-- El botón real de Google se renderiza transparente encima -->
    <div class="google-btn-wrapper">
        <div class="btn-google-register">
            <img class="google-icon" src="assets/images/google_logo.png" alt="">
            {{buttonLabel}}
        </div>
        <div #googleBtnHost class="google-btn-host"></div>
    </div>

    <div class="google-error" *ngIf="error">{{error}}</div>

    <ng-container *ngIf="!buttonOnly">
        <div class="register-divider"><span>o</span></div>

        <button class="btn-email-register" type="button" (click)="onSelectEmail()">
            <i class="mdi mdi-email-outline"></i>
            {{emailLabel}}
        </button>
    </ng-container>
</div>
